import APIConnector from "../lib/APIConnector";
import Settings from '../base/Settings'
const apiConnector = new APIConnector({ timeout: 30000 })

export default class NoveltyConfig {
  static get endpoint(){
    return Settings.SERVICE_DOMAIN
  }
  static get endpointNews() {
    return `${NoveltyConfig.endpoint}/news`;
  }
  static get endpointSaveNovelty() {
    return `${NoveltyConfig.endpointNews}/save`;
  }
  static get endpointDeleteNovelty() {
    return `${NoveltyConfig.endpointNews}/delete`;
  }

  static get APIConnector() {
    return apiConnector
  }
}



// WEBPACK FOOTER //
// ./src/provider/novelty/NoveltyConfig.js